export default {
  Current: 'current',
  Previous: 'previous',
};
